import React from "react";
import { useTranslation } from "react-i18next";
import { Input, Loader } from "semantic-ui-react";

import "components/UploadFilesZone/UploadFilesZone.scss";

type UploadFilesZoneProps = {
  display: boolean;
  hasError: boolean;
  isUploading?: boolean;
  disabled?: boolean;
  onFileInputChange: (evt: React.ChangeEvent<HTMLInputElement>) => void;
  onFileDragOver: (evt: React.DragEvent<HTMLInputElement>) => void;
  onFileDrop: (evt: React.DragEvent<HTMLInputElement>) => void;
};

export const UploadFilesZone = ({ display, onFileDragOver, onFileDrop, onFileInputChange, hasError, isUploading = false, disabled }: UploadFilesZoneProps) => {
  const { t } = useTranslation();

  if (!display) return null;

  const triggerOnChangeOnFileInput = () => {
    if (isUploading || disabled) return;
    document.getElementById("file-input")?.click();
  };

  const handleFileInputChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    onFileInputChange(evt);
    evt.target.value = "";
  };

  const handleDragOver = (evt: React.DragEvent<HTMLInputElement>) => {
    if (isUploading || disabled) {
      evt.preventDefault();
      return;
    }
    onFileDragOver(evt);
  };

  const handleDrop = (evt: React.DragEvent<HTMLInputElement>) => {
    if (isUploading || disabled) {
      evt.preventDefault();
      return;
    }
    onFileDrop(evt);
  };

  return (
    <div
      className={`UploadFilesZone ${hasError ? "error" : ""} ${isUploading ? "uploading" : ""} ${disabled ? "disabled" : ""}`}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      {isUploading && <Loader active inline="centered" size="small" className="upload-loader" />}
      <div>
        <span>
          {t("v8_drag_files", "Drag files")} {t("v8_or", "or")}
        </span>{" "}
        <span className="browse-text" onClick={triggerOnChangeOnFileInput}>
          {t("v8_browse", "Browse")}
        </span>
      </div>
      <div className="max-file-size">{t("v8_maximum_file_size", "Maximum file size")} 32MB</div>
      <Input type="file" id="file-input" onChange={handleFileInputChange} placeholder="Browse" required multiple disabled={isUploading || disabled} />
    </div>
  );
};
